export const productTypeTypes = {
  GET_PRODUCT_TYPE_LIST: "GET_PRODUCT_TYPE_LIST",
  GET_PRODUCT_ITEM_LIST: "GET_PRODUCT_ITEM_LIST",
};